module.exports = __webpack_public_path__ + "static/img/white-0.731bac8b.png";